import { render, staticRenderFns } from "./MenuExportTable.vue?vue&type=template&id=64f90f2b"
import script from "./MenuExportTable.vue?vue&type=script&lang=js"
export * from "./MenuExportTable.vue?vue&type=script&lang=js"
import style0 from "./MenuExportTable.vue?vue&type=style&index=0&id=64f90f2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports